import React, {useState} from 'react';
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
} from 'antd';
import './index.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch } from 'react-redux';
import { signUpUser } from '../../../Store/Actions';
import { applicationConfig } from '../../../Util/config';
import {
  maxTagPlaceholder,
  tagRender,
  validateEmailInput,
  validatePhoneNumber,
  OnlyAlphabetInputValidator,
  NoEmptySpaceInput,
  UserPasswordValidator,
  validateCompanyName,
  OnlyAlphabetInputValidatorWithSpecialCharacters,
  useCountryState,
  getTopmostErrorField,
  scrollAndFocusFormErrorField,
} from '../../../Util/commonUtility';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import useLocalization from '../../../Localization';
import ViewportSelect from '../ViewportPopup/ViewportSelect';

const RegisterForm = ({
  chaptersList,
  keywordsOptions,
  chaptersListForAnnouncements,
  pbssInternationalData,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ApplicationString } = useLocalization();
  const [registerForm] = Form.useForm();
  const chapterDataArray = chaptersList?.map((chapter) => chapter?.value);
  const [chapterWithoutLocalForMail, setchapterWithoutLocalForMail] =
    useState();
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [checkboxState, setCheckboxState] = useState([]);
  const [tags, setTags] = useState([]);
  const {
    stateOptions,
    selectedCountry,
    selectedStates,
    countriesData,
    handleStateChange,
    handleCountryChange,
  } = useCountryState(null, registerForm);

  const onRegister = (values) => {
    const Data = {
      ...values,
      phone_number: values?.phone_number ? values?.phone_number : null,
      state: values?.state ? values?.state : '',
      mail_preference: values?.mail_preference || [],
      area_of_interest: tags?.toString(),
      user_keywords: selectedKeywords,
    };
    const successMessage =
      ApplicationString['userRegistrationComponent.successMessage'];
    dispatch(signUpUser(Data, navigate, successMessage));
  };
  const onReset = () => {
    registerForm.resetFields();
    registerForm.setFieldsValue({
      user_keywords: [],
    });

    setSelectedKeywords([]);
    setTags([]);
  };

  const onRegisterFailed = (errorInfo) => {
    scrollAndFocusFormErrorField(
      getTopmostErrorField(errorInfo, 'registerForm'),
      registerForm,
    );
  };

  const handleSelectMailChange = (value) => {
    const selectAllData = chapterDataArray?.map((item) => item?.value);
    if (value.includes('all')) {
      setCheckboxState([...selectAllData, 'all']);
      registerForm.setFieldsValue({
        mail_preference: chapterDataArray,
      });
      setchapterWithoutLocalForMail(chapterDataArray);
    } else {
      setCheckboxState(value);
      setchapterWithoutLocalForMail(value);
    }
  };

  const handleMailPrefCheckboxChange = (value, checked) => {
    const selectedValues = chaptersList
      ?.filter((item) => item?.value !== 'all')
      ?.map((item) => item?.value);
    if (checked) {
      if (value == 'all') {
        setCheckboxState([...selectedValues, 'all']);
      } else {
        setCheckboxState([...checkboxState, value]);
      }
    } else {
      if (value == 'all') {
        setCheckboxState([]);
        registerForm.setFieldsValue({
          mail_preference: [],
        });
      } else {
        setCheckboxState(checkboxState.filter((item) => item !== value));
      }
    }
  };

  const handleKeywordChange = (value) => {
    setSelectedKeywords(value);
  };

  return (
    <Form
      // {...formItemLayout}
      layout='vertical'
      form={registerForm}
      name='registerForm'
      onFinish={onRegister}
      onFinishFailed={onRegisterFailed}
      initialValues={''}
      className='register-form'>
      <Row gutter={14}>
        <Col xs={24} sm={12}>
          <Form.Item
            name='first_name'
            rules={[
              {
                required: true,
                message: ApplicationString['userRegisterComponent.firstName'],
              },
              {
                validator: (_, value) =>
                  OnlyAlphabetInputValidatorWithSpecialCharacters(
                    value,
                    'First name',
                    254,
                    ApplicationString[
                      'userRegisterComponent.firstNameValidation'
                    ],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                prefix={'*'}
                placeholder={
                  ApplicationString['userRegisterComponent.firstName']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name='last_name'
            rules={[
              {
                required: true,
                message: ApplicationString['userRegisterComponent.lastName'],
              },
              {
                validator: (_, value) =>
                  OnlyAlphabetInputValidatorWithSpecialCharacters(
                    value,
                    'Last name',
                    254,
                    ApplicationString[
                      'userRegisterComponent.lastNameValidation'
                    ],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                prefix={`*`}
                placeholder={
                  ApplicationString['userRegisterComponent.lastName']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col xs={24} sm={12}>
          <Form.Item
            name='email'
            rules={[
              {
                required: true,
                message: ApplicationString['userRegisterComponent.email'],
              },
              {
                validator: (_, value) =>
                  validateEmailInput(
                    value,
                    'Email',
                    ApplicationString['userRegisterComponent.emailValidation'],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                prefix={'*'}
                placeholder={ApplicationString['userRegisterComponent.email']}
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name='confirm_email'
            className='email-bottom-compact'
            dependencies={['email']}
            hasFeedback
            rules={[
              {
                required: true,
                message:
                  ApplicationString['userRegisterComponent.confirmEmail'],
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('email') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      ApplicationString[
                        'userRegisterComponent.emailValidation'
                      ],
                    ),
                  );
                },
              }),
            ]}>
            <div className='register-form-input-container'>
              <Input
                prefix={'*'}
                placeholder={
                  ApplicationString['userRegisterComponent.confirmEmail']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Alert
        type='info'
        showIcon
        message={ApplicationString['userRegisterComponent.addNote']}
        className='register-email-note'
      />
      <Row gutter={14}>
        <Col xs={24} sm={12}>
          <Form.Item
            name='password'
            rules={[
              {
                required: true,
                message: ApplicationString['userRegisterComponent.password'],
              },
              {
                validator: (_, value) =>
                  UserPasswordValidator(_, value, {
                    empty:
                      ApplicationString[
                        'userRegisterComponent.passwordSpaceValidation'
                      ],
                    space:
                      ApplicationString[
                        'userRegisterComponent.passwordEmptyValidation'
                      ],
                    minLength:
                      ApplicationString[
                        'userRegisterComponent.passwordValidation'
                      ],
                  }),
              },
            ]}
            hasFeedback>
            <div className='register-form-input-container'>
              <Input.Password
                prefix={<span className={`ant-input-prefix`}>*</span>}
                placeholder={
                  ApplicationString['userRegisterComponent.password']
                }
                className='common-input-register'
              />
            </div>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name='confirm'
            dependencies={['password']}
            hasFeedback
            rules={[
              {
                required: true,
                message:
                  ApplicationString['userRegisterComponent.confirmPassword'],
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      ApplicationString[
                        'userRegisterComponent.passwordValidation'
                      ],
                    ),
                  );
                },
              }),
            ]}>
            <div className='register-form-input-container'>
              <Input.Password
                prefix={'*'}
                placeholder={
                  ApplicationString['userRegisterComponent.confirmPassword']
                }
                className='common-input-register'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col xs={24} sm={12}>
          <Form.Item
            name='address'
            rules={[
              {
                required: false,
                message: ApplicationString['userRegisterComponent.address'],
              },
              {
                validator: (_, value) =>
                  NoEmptySpaceInput(
                    value,
                    'Address Line 1',
                    255,
                    ApplicationString[
                      'userRegisterComponent.address1Validation'
                    ],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                prefix={` `}
                placeholder={
                  ApplicationString['userRegisterComponent.addressLine1']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name='address2'
            rules={[
              {
                required: false,
                message: ApplicationString['userRegisterComponent.address'],
              },
              {
                validator: (_, value) =>
                  NoEmptySpaceInput(
                    value,
                    'Address Line 2',
                    255,
                    ApplicationString[
                      'userRegisterComponent.address2Validation'
                    ],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                prefix={` `}
                placeholder={
                  ApplicationString['userRegisterComponent.addressLine2']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col xs={24} sm={12}>
          <Form.Item
            name='city'
            rules={[
              // {
              //   validator: (_, value) =>
              //     useOnlyAlphabetInputValidator(value, 'City'),
              // },
              {
                validator: (_, value) =>
                  OnlyAlphabetInputValidator(
                    value,
                    'City',
                    254,
                    ApplicationString['userRegisterComponent.cityValidation'],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                placeholder={
                  ApplicationString['userRegisterComponent.cityTown']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name='postal_code'
            rules={[
              {
                required: true,
                message:
                  ApplicationString['userRegisterComponent.zipCodeRequired'],
              },
              {
                validator: (_, value) =>
                  NoEmptySpaceInput(
                    value,
                    'Zip code',
                    255,
                    ApplicationString[
                      'userRegisterComponent.zipCodeValidation'
                    ],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                prefix={'*'}
                placeholder={
                  ApplicationString['userRegisterComponent.zipPostalCode']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col xs={24} sm={12}>
          <Form.Item
            name='country'
            rules={[
              {
                required: true,
                message: ApplicationString['userRegisterComponent.country'],
              },
            ]}>
            <div className='register-form-input-container'>
              <ViewportSelect
                prefixCls='register-select-country'
                showSearch
                className='space register-form-selection country-state local-select'
                allowClear
                optionFilterProp='children'
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? '').includes(
                    input?.toLowerCase(),
                  )
                }
                value={selectedCountry}
                onChange={handleCountryChange}
                placeholder={ApplicationString['userRegisterComponent.country']}
                options={countriesData}></ViewportSelect>
            </div>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name='state'
            initialValue={''}
            rules={[
              {
                required: true,
                message:
                  ApplicationString['userRegisterComponent.stateRequired'],
              },
            ]}>
            <div className='register-form-input-container'>
              <ViewportSelect
                prefixCls='register-select-country-state'
                showSearch
                className='space register-form-selection country-state local-select'
                allowClear
                optionFilterProp='children'
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? '').includes(
                    input?.toLowerCase(),
                  )
                }
                value={stateOptions}
                onChange={handleStateChange}
                placeholder={
                  ApplicationString['userRegisterComponent.stateProvinceRegion']
                }
                options={selectedStates}
                disabled={!selectedCountry}></ViewportSelect>
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col span={24}>
          <Form.Item
            name='company'
            extra={
              <span className='register-field-help'>
                {
                  ApplicationString[
                    'userRegisterComponent.companyName.helpText'
                  ]
                }
              </span>
            }
            label={
              <div className='register-select-label'>
                <span className='ant-input-prefix'>* </span>
                {ApplicationString['userRegisterComponent.companyNameLabel']}
              </div>
            }
            rules={[
              {
                required: true,
                message: ApplicationString['userRegisterComponent.companyName'],
              },
              {
                validator: (_, value) =>
                  validateCompanyName(
                    value,
                    'Company name',
                    255,
                    ApplicationString[
                      'userRegisterComponent.companyNameValidation'
                    ],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                placeholder={
                  ApplicationString[
                    'userRegisterComponent.companyName.placeholder'
                  ]
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col span={24}>
          <Form.Item
            name='title'
            extra={
              <span className='register-field-help'>
                {ApplicationString['userRegisterComponent.jobTitle.helpText']}
              </span>
            }
            label={
              <div className='register-select-label'>
                <span className='ant-input-prefix'>* </span>
                {ApplicationString['userRegisterComponent.jobTitle.label']}
              </div>
            }
            rules={[
              {
                required: true,
                message:
                  ApplicationString['userRegisterComponent.jobTitle.required'],
              },
              {
                validator: (_, value) =>
                  NoEmptySpaceInput(
                    value,
                    'Job title',
                    255,
                    ApplicationString[
                      'userRegisterComponent.jobTitleValidation'
                    ],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                placeholder={
                  ApplicationString[
                    'userRegisterComponent.jobTitle.placeholder'
                  ]
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col span={24}>
          <Form.Item
            name='phone_number'
            label={
              <div className='register-select-label'>
                {ApplicationString['userRegisterComponent.contactNumber.title']}
              </div>
            }
            rules={[
              {
                validator: (_, value) =>
                  validatePhoneNumber(
                    value,
                    'phone number',
                    ApplicationString[
                      'userRegisterComponent.contactNumberValidation'
                    ],
                  ),
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                placeholder={
                  ApplicationString['userRegisterComponent.contactNumber']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={14}>
        <Col span={24}>
          <Form.Item
            name='local_chapter_id'
            label={
              <div className='register-select-label'>
                <span className='ant-input-prefix'>* </span>
                {ApplicationString['userRegisterComponent.localChapter']}
              </div>
            }
            rules={[
              {
                required: true,
                message:
                  ApplicationString['userRegisterComponent.localChapter'],
              },
            ]}>
            <ViewportSelect
              prefixCls='register-select-local-chapter'
              showSearch
              className='space register-form-selection local-select'
              // optionFilterProp='children'
              allowClear
              optionFilterProp='children'
              filterOption={(input, option) =>
                String(option?.label ?? '').toLowerCase().includes(String(input ?? '').toLowerCase())
              }
              placeholder={
                ApplicationString['userRegisterComponent.localChapter']
              }
              options={chaptersList}></ViewportSelect>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col span={24}>
          <Form.Item
            name='mail_preference'
            initialValue={chapterWithoutLocalForMail}
            label={
              <div className='register-select-label'>
                <span className='ant-input-prefix'></span>
                {ApplicationString['userRegisterComponent.selectChapter.title']}
              </div>
            }>
            <ViewportSelect
              id='basic-selection-chapters'
              prefixCls='register-select-input'
              className='space register-form-selection'
              mode='multiple'
              showSearch
              allowClear
              // optionFilterProp='children'
              filterOption={(input, option) => {
                const searchText = option?.searchLabel || ""
                return String(searchText)
                  .toLowerCase()
                  .includes(String(input ?? '').toLowerCase());
              }}
              placeholder={
                ApplicationString['userRegisterComponent.selectChapter']
              }
              onChange={handleSelectMailChange}
              maxTagCount={'responsive'}
              maxTagPlaceholder={maxTagPlaceholder}
              tagRender={tagRender}
              value={registerForm.getFieldValue('mail_preference')}
              options={
                (chaptersListForAnnouncements &&
                  chaptersListForAnnouncements?.map((item) => ({
                    label: (
                      <Checkbox
                        checked={checkboxState.includes(item.value)}
                        onChange={(e) =>
                          handleMailPrefCheckboxChange(
                            item.value,
                            e.target.checked,
                          )
                        }>
                        {item.label}
                      </Checkbox>
                    ),
                    value: item.value,
                    searchLabel:
                      typeof item.label === 'string' ? item.label : '',
                  }))) ||
                []
              }></ViewportSelect>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={14}>
        <Col span={24}>
          <Form.Item
            label={
              <div className='register-select-label'>
                <span className='ant-input-prefix'></span>
                {ApplicationString['userRegisterComponent.selectArea']}
              </div>
            }
            name='user_keywords'>
            <ViewportSelect
              prefixCls='register-select-input'
              className='space register-form-selection'
              mode='multiple'
              showSearch
              allowClear
              optionFilterProp='children'
              filterOption={(input, option) =>
                option?.label?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
              }
              onChange={handleKeywordChange}
              maxTagCount={'responsive'}
              maxTagPlaceholder={maxTagPlaceholder}
              tagRender={tagRender}
              placeholder={
                ApplicationString['userRegisterComponent.selectArea']
              }
              options={keywordsOptions}></ViewportSelect>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            label={
              <div className='register-select-label'>
                {ApplicationString['userRegisterComponent.addOtherInterests']}
              </div>
            }
            name='area_of_interest'
            rules={[
              {
                required: false,
                message:
                  ApplicationString['userRegisterComponent.addOtherInterests'],
              },
              {
                validator: (_, value) => {
                  const regex = /\s{4,}/g;
                  // added extra validation cause it was causing second error message from antd
                  if (value && value?.length <= 0) {
                    return Promise.reject(new Error(''));
                  }
                  if (value && value.trim() === '') {
                    return Promise.reject(
                      new Error(
                        ApplicationString[
                          'userRegisterComponent.addOtherInterests'
                        ],
                      ),
                    );
                  } else if (value && regex.test(value)) {
                    return Promise.reject(
                      new Error(
                        ApplicationString[
                          'userRegisterComponent.addOtherInterests'
                        ],
                      ),
                    );
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}>
            <div className='register-form-input-container'>
              <Input
                prefix={` `}
                placeholder={
                  ApplicationString['userRegisterComponent.enterAreas']
                }
                className='register-form-input'
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Row
          gutter={{
            xs: 4,
            sm: 4,
            md: 8,
            lg: 20,
          }}>
          <Col xs={24} sm={24} md={24} lg={10}>
            <Form.Item name='is_vendor' className='vendor-check'>
              <Checkbox
                prefixCls='keyword-checkbox'
                className='gap'
                valuePropName='checked'>
                <span className='register-select-label'>
                  {
                    ApplicationString[
                      'userRegisterComponent.vendorRepresentative'
                    ]
                  }
                </span>
              </Checkbox>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Form.Item
              name='isTermsAccepted'
              initialValue={true}
              valuePropName='checked'>
              <div className='flex flex-wrap gap-1 register-select-label'>
                <span>
                  {
                    ApplicationString[
                      'userRegisterComponent.iAcceptTermsAndConditions.title1'
                    ]
                  }
                </span>{' '}
                <a
                  href={`${applicationConfig.UPLOAD_URL}/${pbssInternationalData?.terms_and_conditions_id?.name}`}
                  rel='noopener noreferrer'
                  target='_blank'
                  className='under-line register-select-label-under-line register-select-label register-select-label-link'>
                  {
                    ApplicationString[
                      'userRegisterComponent.iAcceptTermsAndConditions.title2'
                    ]
                  }
                </a>{' '}
                <span>
                  {
                    ApplicationString[
                      'userRegisterComponent.iAcceptTermsAndConditions.title3'
                    ]
                  }
                </span>
              </div>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={16}>
            <Form.Item
              className='vendor-check'
              label={ApplicationString['userRegisterComponent.captcha.title']}
              name='captcha'
              rules={[
                {
                  required: true,
                  message: ApplicationString['userRegisterComponent.captcha'],
                },
              ]}>
              <ReCAPTCHA
                sitekey={applicationConfig.CAPTCHA_SITE_KEY}></ReCAPTCHA>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>

      <Divider />
      <Row gutter={40} className='register-buttons'>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Form.Item>
            <Button
              prefixCls='register-submit'
              id='register-register-button'
              type='primary'
              className='register-button'
              htmlType='submit'>
              {ApplicationString['userRegisterComponent.register']}
            </Button>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Form.Item>
            <Button
              prefixCls='register-cancel'
              id='register-cancel-button'
              className='register-button'
              onClick={onReset}>
              {ApplicationString['userRegisterComponent.cancel']}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default RegisterForm;
